import * as React from 'react';
import ConnectedThemeProvider from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/ThemeProvider';
import merge from 'lodash/merge';

const customTheme = {};

const overrideTheme = (theme) => {
  merge(theme.overrides, {
    Header: {
      headerRoot: {
        backgroundColor: '#ffffff',
      },
    },
    ProductPart: {
      rootTypography: {
        overflow: 'unset'
      }
    }
  });
};

export default ({ children }) => (
  <ConnectedThemeProvider customTheme={customTheme} withTheme={overrideTheme}>
    {children}
  </ConnectedThemeProvider>
);
